import { ChangeEvent, Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useWindowSize } from '../../../../../../utils/hooks/useWindowSize'
import Select from 'react-select'
import { useThemeMode } from '../../../../../../_metronic/partials'
import { SelectStyles } from '../../../../../../components/Select'

export interface IAdapter {
  amountRequired: boolean
  createdAt: string
  enabled: boolean
  id: string
  minDeposit: number
  maxDeposit: number
  name: string
  updatedAt: string
  usingExternalGateway: boolean
  useTrafficType: string
}

interface PaymentAdapterCardProps {
  item: IAdapter
  onToggle: (e: ChangeEvent<HTMLInputElement>, item: any) => void
  setAdapter: Dispatch<SetStateAction<never[]>>
  sourceValue?: string
  readOnly?: boolean
}

function PaymentAdapterCard({ item, onToggle, setAdapter, sourceValue, readOnly = false }: PaymentAdapterCardProps) {
  const { mode: theme } = useThemeMode()

  const [sum, setSum] = useState<number>(item?.minDeposit || 0)
  const [sumMax, setSumMax] = useState<number>(item?.maxDeposit || 0)
  const [utt, setUtt] = useState<string>('NONE')
  const { width } = useWindowSize()

  const uttVals = [
    { value: 'NONE', label: 'Любой трафик' },
    { value: 'FIRST', label: 'Только первичный' },
    { value: 'SECOND', label: 'Только вторичный' },
  ];

  useEffect(() => {
    setSum(item?.minDeposit || 0)
    setSumMax(item?.maxDeposit || 0)
    setUtt(item?.useTrafficType || 'NONE')
  }, [item])

  return (
    <div className='flex' key={item?.id}>
      <div className='d-flex align-items-center' style={{ height: '76px' }}>
        <div className={`${width <= 540 ? 'w-60px me-4' : 'w-90px me-10'}  me-10`}>
          <input
            name='minDeposit'
            disabled={readOnly}
            className='form-control form-control-solid'
            placeholder='Введите сумму'
            value={sum}
            onChange={(e) => {
              if (!Number.isNaN(Number(e.target.value))) {
                setSum(Number(e.target.value))
                setAdapter((prev: any) =>
                  prev.map((el: any) =>
                    el.name === item.name ? { ...el, minDeposit: Number(e.target.value) } : el
                  )
                )
              }
            }}
          />
        </div>
        <div className={`${width <= 540 ? 'w-60px me-4' : 'w-90px me-10'}  me-10`}>
          <input
            name='maxDeposit'
            disabled={readOnly}
            className='form-control form-control-solid'
            placeholder='Введите сумму'
            value={sumMax}
            onChange={(e) => {
              if (!Number.isNaN(Number(e.target.value))) {
                setSumMax(Number(e.target.value))
                setAdapter((prev: any) =>
                  prev.map((el: any) =>
                    el.name === item.name ? { ...el, maxDeposit: Number(e.target.value) } : el
                  )
                )
              }
            }}
          />
        </div>
        <div className={`${width <= 540 ? 'w-60px me-4' : 'w-150px me-10'}  me-10`}>
          <Select  
              styles={SelectStyles(theme)}
              isDisabled={readOnly}
              onChange={(e) => {
                setUtt(e?.value!)
                setAdapter((prev: any) =>
                  prev.map((el: any) =>
                    el.name === item.name ? { ...el, useTrafficType: e?.value! } : el
                  )
                )
              }}
              value={uttVals.find(v => v.value === utt) ?? null}
              options={uttVals}
          />
        </div>
        <div className='d-flex form-check form-check-solid form-switch fv-row me-10'>
          <input
            style={{ cursor: readOnly ? 'default' : 'pointer' }}
            className='form-check-input w-45px h-30px'
            type='checkbox'
            disabled={readOnly}
            checked={item?.enabled}
            onChange={(e) => onToggle(e, item)}
          />
        </div>
        <div style={{ width: '110px', minWidth: '110px', flexShrink: 0, display: 'flex', alignItems: 'center' }}>
          <span className='text-gray-800 fw-bold'>
            {sourceValue || 'MERCHANT'}
          </span>
        </div>
      </div>
    </div>
  )
}

export default PaymentAdapterCard
